import AddressToAccountForComments from "./CommentItem.jsx"
import { comments } from '../../lib/api';
import { sessionStorageGet } from '../../lib/window-shim';
import React, {useEffect, useState} from "react";

import "./fader.css"

/**
 * Comments - Collapsible comment section with threaded replies
 *
 * @param {Object} props
 * @param {string} props.itemHash - Unique identifier for the item being commented on
 * @param {number} props.start - Pagination start index
 * @param {number} props.end - Pagination end index
 * @param {string|null} props.metaAction - Optional metadata action for new comments
 * @param {string|null} props.actionLocation - Optional metadata location for new comments
 * @param {Object|null} props.actionMedia - Optional media for new comments: { url, name }
 * @param {boolean} props.noDisplayMedia - Suppress media display in comments if true
 */
const Comments = ({itemHash, start, end, metaAction, actionLocation, actionMedia, noDisplayMedia}) => {
    const [comms, sComms] = useState([])
    const [commsCnt, scTotal] = useState(null)
    const [collapse, sCollapse] = useState(true);

    let ui;
    try {
        ui = JSON.parse(sessionStorageGet('token') ?? 'null').account;
    } catch (e) {}

    const submitComment = async () =>{
        let commentElem = document.getElementById("comment");
        let comment = commentElem.value;
        commentElem.value=""
        let jData = {start: start, end: end, hash: itemHash, comment: comment, forUser: null, meta: {}}
        if(metaAction) jData.meta.action = metaAction
        if(actionLocation) jData.meta.actionLocation = actionLocation
        if(actionMedia && actionMedia?.url) { jData.meta.fileObjects = [{url: actionMedia?.url, name: actionMedia?.name, mime: "image/jpg"}] }
        let response = await comments(jData)
        sComms(response.comms)
        scTotal(response.cc)
    }

    useEffect(() => {
        let jData = {start: start, end: end, hash: itemHash, forUser: null}
        comments(jData)
            .then(response => {
                sComms(response.comms)
                scTotal(response.cc)
            })
    }, [end, itemHash, start])

    useEffect( ()=>{
        return () => { sComms([]) }
    }, [])

    const genComments = (comms, ui) => {
        let opt;
        if(comms?.length) {
            opt = comms.slice(0).reverse().map((item) => <React.Fragment key={item.id}> {
                <AddressToAccountForComments flags={"bob"}
                                             userId={item.userId}
                                             item={item}
                                             noDisplayMedia={noDisplayMedia}
                                             currUser={ui}
                /> } </React.Fragment> )
        }
        return(opt)
    }

    async function toggleCollapse(){
        const csDiv = document.getElementById("commsDiv")
        if(collapse){
            sCollapse(false)
            csDiv.style.visibility="visible";
            csDiv.style.display="block";
        } else {
            sCollapse(true)
            csDiv.style.visibility="hidden";
            csDiv.style.display="none";
        }
    }

    return (
        <div className="ms-1 me-1 pt-1 pb-1">
            <div className="pixel-card">
                <div onClick={()=>toggleCollapse()} style={{ display: "flex", flexDirection: "row", padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                    <div className="text-white fw-semibold" style={{flexGrow: 1}}>
                        Comments {commsCnt ? "("+commsCnt+")" : ""}
                    </div>
                    <div className="me-2 text-secondary" style={{fontWeight: "bold", marginLeft: "auto"}}>
                        ›
                    </div>
                </div>
                <div id="commsDiv" className="fadeMe m-2" style={{display: "none", visibility: "hidden", transition: "0.25s ease"}} >
                    <div className="mb-2">
                        <input id="comment" placeholder={"Add your comment here"} style={{fontSize: "0.9rem", background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '6px 10px'}} className="w-75 ms-2" />
                        <button onClick={()=>submitComment()} className="btn btn-sm btn-outline-secondary ms-2">→</button>
                    </div>
                    {genComments(comms, ui)}
                </div>
            </div>
        </div>
    )
}

export default Comments;
